import React, { Component } from 'react';
import FooterItem from './footeritem/FooterItem';
// import ConnectUsModal from '../ContactUsModal';
import EnterpriseWeChat from '../EnterpriseWeChat';
import './Footer.less';


class Footer extends Component {
  render() {
    const { theme, data = {} } = this.props;
    const { connect = {}, account= {}, quickEntrance = {}, 
    products = {}, about = {}, footerData = {} } = data;
    const { btnData = {}, qrData = [] } = about;
    const { modalContent = {} } = btnData;
    const { leftData = [], rightData = [] } = footerData;

    return (
      <div className={`cn-open-footer ${theme}`} id='cn-open-footer'>
        <div style={{paddingRight:'60px',paddingLeft:'60px'}} className="cn-open-footer-container adaptive">
          <div className="footer-item-container">
            <FooterItem itemData={connect} type="connect" />
          </div>

          <div className="footer-item-container">
            <FooterItem itemData={account} type="account" />
          </div>

          <div className="footer-item-container">
            <FooterItem itemData={quickEntrance} type="quickEntrance" />
          </div>
          <div className="footer-item-container">
            <FooterItem itemData={products} type="products" />
          </div>
          <div className="footer-item-container">
            <div className="footer-item-title">{about.title||'关注或联系我们'}</div>
            {about.description && <div className='footer-item-description'>{about.description}</div>}
            <div className="qr">
              {qrData.map((item, index) => {
                return (
                  <div key={'qr' + index}>
                    <img src={item.imgUrl} alt="qc" />
                    <div onClick={() =>{
                      if(!!item.href){
                        window.open(item.href)
                      }
                    }} 
                    style={{cursor: !!item.href ? 'pointer' : 'default'}}
                    className="name">{item.title}</div>
                  </div>
                )
              })}
            </div>
            {btnData.clickMode === 2 ? 
              <EnterpriseWeChat 
                ptype={modalContent.ptype}
                title={modalContent.weChatTitle || "联系我们"}
                weChatImg={modalContent.weChatImg || "https://resource.eziot.com/group1/M00/00/8F/CtwQE2MHDr-AOVTTAAAGDyC5ekQ047.png"}
                weChatDesc={modalContent.weChatDesc || "微信扫一扫联系我们"}
                parentNode={()=>document.getElementsByClassName('cn-fixed-bar-wrap')[0]}
              >
                <div className="footer-consult">{btnData.title||'在线咨询'}</div>
              </EnterpriseWeChat> :
              // <ConnectUsModal width={458} height={648} simpleDescription="首页-商务咨询2">
              <div onClick={()=>{
                let url = btnData.href || "https://ywrobot.ys7.com/robot/chat2.html?jid=607&sysNum=1544515797023401&sourceId=1797"
                window.open(url)
              }} className="footer-consult">{btnData.title||'在线咨询'}</div>
              // </ConnectUsModal>
            }
          </div>
        </div>
        <div className="open-footer-divide" />
        <div className="cn-open-footer-copyright">

          <div className="copyright-left">
            <span style={{color: '#666666'}}>©2013-{new Date().getFullYear()}</span>
            {
              leftData.map((item, index) => {
                if(!!item.href){
                  return (
                    <a 
                      href={item.href} 
                      target={item.target || "_blank"} 
                      key={'copyright-left' +index} 
                      style={{marginLeft: '6px',color: '#666666'}} >
                      {item.title}
                    </a>
                  )
                }
                return (
                  <span key={'copyright-left' +index} style={{marginLeft: '6px',color: '#666666'}} >
                    {item.title}
                  </span>
                )
              })
            }
          </div>
          <div className="copyright-right">
            {
              rightData.map((item, index) => {
                return (<span key={'copyright-right' + index}>
                  <span className="divide" />
                  <span>
                    <a 
                    style={{color: '#666666'}}
                    onClick={()=>{
                     
                    }}
                    href={item.href || ''} target={item.target || "_self"}>{item.title || ''}</a>
                  </span>
                </span>)
              })
            }
          </div>
        </div>
      </div>
    );
  }
}
export default Footer;
